module.exports = __webpack_public_path__ + "static/media/activities-image-1.7ee0bced.png";